(function () {
  if (window.__veloraReadMore) return;
  window.__veloraReadMore = true;

  function setup(el) {
    if (!el || el.__vrm) return;
    el.__vrm = true;
    el.classList.add('velora-collapse', 'is-clamped');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'velora-readmore';
    btn.textContent = 'Read more';
    el.parentNode.insertBefore(btn, el.nextSibling);
    requestAnimationFrame(function () {
      if (el.scrollHeight <= el.clientHeight + 4) {
        el.classList.remove('is-clamped');
        if (btn.parentNode) btn.parentNode.removeChild(btn);
        return;
      }
      btn.addEventListener('click', function () {
        var clamped = el.classList.toggle('is-clamped');
        btn.textContent = clamped ? 'Read more' : 'Read less';
      });
    });
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) return;
    var els = document.querySelectorAll('.velora-ba__body, .velora-guar__body, .velora-problem__body');
    for (var i = 0; i < els.length; i++) setup(els[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();